module.exports = __webpack_public_path__ + "img/7.e6f865f8.webp";